<div class="modal-header">
  <h4 class="modal-title pull-left">{{ 'worker.pair' | translate }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="modalRef.close()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (!qrCode) {
    <div
      class="d-flex justify-content-center align-content-center pt-2 pb-2"
      style="height: 25px; padding-top: 10px; background-color: #ffffff"
    >
      <mat-spinner class="position-absolute" [diameter]="25"></mat-spinner>
    </div>
  }
  @if (qrCode) {
    <div>
      <qrcode
        [qrdata]="qrCode"
        [width]="256"
        [errorCorrectionLevel]="'M'"
      ></qrcode>
      <div>
        <a (click)="refreshQrCode()" class="float-end">{{
          'qr_refresh' | translate
        }}</a>
        @if (expires) {
          <span>{{ timeRemaining | countdownTimer }}</span>
        }
      </div>
    </div>
  }
</div>
<app-error [error]="error"></app-error>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="modalRef.close()"
  >
    {{ 'close' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-secondary"
    (click)="printQR()"
    [ladda]="isQRLoading"
  >
    {{ 'worker.print_qr' | translate }}
  </button>
</div>

<!-- PDF Definition -->
<div #pdfContent class="d-none">
  <div class="page a4" style="padding: 16px">
    <img src="./assets/img/logo.png" width="200" />
    <h4 style="margin-left: 110px; margin-top: 48px; width: 320px">
      {{ 'productivity_cloud' | translate }}
    </h4>
    <div style="display: flex; margin-top: 32px">
      <div>
        <h5 style="margin-left: 34px">
          {{ 'qr_print_page.download' | translate }}
        </h5>
        <h5 style="margin-left: 16px">{{ 'qr_print_page.app' | translate }}</h5>
        @if (latestAppDownloadLink) {
          <qrcode
            #downloadQR
            [qrdata]="latestAppDownloadLink"
            [width]="160"
            [imageHeight]="160"
            [errorCorrectionLevel]="'H'"
            [elementType]="'img'"
            [margin]="0"
          ></qrcode>
        }
      </div>
      <div style="margin-left: 92px">
        <h5 style="margin-left: 56px">
          {{ 'qr_print_page.login' | translate }}
        </h5>
        <h5 style="margin-left: 16px">{{ 'qr_print_page.app' | translate }}</h5>
        @if (userQRData) {
          <qrcode
            #loginQR
            [qrdata]="userQRData"
            [width]="160"
            [imageHeight]="160"
            [errorCorrectionLevel]="'H'"
            [elementType]="'img'"
            [margin]="0"
          ></qrcode>
        }
      </div>
    </div>
    <div style="width: 500px; margin-top: 90px">
      <h5>{{ 'qr_print_page.worker_detail' | translate }}</h5>
    </div>
    <div style="display: flex; margin-top: 16px">
      @if (worker.email) {
        <div style="margin-right: 32px">
          <img
            class="rounded-circle"
            width="80"
            height="80"
            src="{{ profileImg }}"
          />
        </div>
      }
      <div>
        <h6>{{ worker.given_name }} {{ worker.family_name }}</h6>
        @if (worker.email) {
          <h6>{{ worker.email }}</h6>
        }
      </div>
    </div>
  </div>
</div>
